if (!customElements.get('add-on-opener')) {
  customElements.define(
    'add-on-opener',
    class AddOnOpener extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.drawer = document.querySelector('cart-drawer');
        this.drawerContent = document.querySelector('#upsell-drawer .upsell-content');
        this.addEventListener('click', this.openDrawer);
      }

      async openDrawer() {
        if(this.dataset.addonType === 'cart-drawer') window.cart_upsell_drawer_tab = 1;
        let productMaterialFound = '';
        const handle = this.dataset.productHandle
        const sectionId = this.dataset.type;
        let variantId = this.dataset.variantId;
        const noParent = this.hasAttribute('no-parent');
        const parentLineItemId = this.dataset.parentLineItemId;
        const parentLineItemKey = this.dataset.parentLineItemKey;
        let endpoint = Shopify.routes.root;
        const addonGender = this.getAttribute('data-addon-option-gender');
        const addonSizeWomen = this.getAttribute('data-addon-option-size-women');
        const addonSizeMen = this.getAttribute('data-addon-option-size-men');
        const parentMaterialTag = this.getAttribute('data-parent-material-tag') || '';
        const addonBlockCollectionProducts = this.getAttribute('data-block-collection-products');

        if (handle) {
          endpoint += `products/${handle}`;
        }

        const params = ['section_id=' + sectionId];

        // update addon size variable if size is changed from addon
        if(this.hasAttribute('data-option-size')) {
          window.addon_current_size_option = Number(this.querySelector('.size-value').textContent);
        }

        // get active size variant id on selecting different product
        if(this.hasAttribute('data-fetch-option') && window.addon_current_size_option && window.addon_current_size_option !== 0) {
          const tempParams = endpoint + '.json' + '?' + params;
          await fetch(tempParams)
          .then(res => res.json())
          .then(data => {
            const sizeValue = window.addon_current_size_option.toString();
            const sizePosition = data.product.options.find(option => option.name === window.size_option_name)?.position;
            const sizeVariantId = data.product.variants.find(variant => variant[`option${sizePosition}`] === sizeValue)?.id;
            if(sizeVariantId) variantId = sizeVariantId;
          })
          .catch(error => console.error(error));
        }


        // case (insole): data-same-option-addon === true, will add same size addon as parent
        if(this.getAttribute('data-same-option-addon') === 'true') {
          const isAddonParentUnisex = this.getAttribute('data-addon-parent-unisex') === 'true' || 'false';

          await fetch(`/?section_id=${sectionId}`)
          .then(res => res.text())
          .then(data => {
            const addonHtml = new DOMParser().parseFromString(data, 'text/html');
            const addonSizes = addonHtml?.querySelectorAll('.add-on__option-size-list .add-on__option-size');

            // rendering loop according to product type. if parent is unisex than skip gender checking
            if(isAddonParentUnisex === true) {
              addonSizes?.forEach(size => {
                const addon = size.querySelector('add-on-opener');
                if(addon.getAttribute('data-variant-option-size-women') === addonSizeWomen && addon.getAttribute('data-variant-option-size-men') === addonSizeMen) {
                  endpoint += `products/${addon.getAttribute('data-product-handle')}`;
                  variantId = addon.getAttribute('data-variant-id');
                }
              })
            } else {
              addonSizes?.forEach(size => {
                const addon = size.querySelector('add-on-opener');
                if(addon.getAttribute('data-variant-option-gender') === addonGender && addon.getAttribute('data-variant-option-size-women') === addonSizeWomen && addon.getAttribute('data-variant-option-size-men') === addonSizeMen) {
                  endpoint += `products/${addon.getAttribute('data-product-handle')}`;
                  variantId = addon.getAttribute('data-variant-id');
                }
              })
            };
          })
          .catch(error => console.error(error));
        }


        // case (laces): data-laces-option-addon === true, will add laces addon according to size mapping
        if(this.getAttribute('data-laces-option-addon') === 'true') {
          let addonGroupSize = -1;
          const lacesSizeMapping = {
            1: ['5','5.5','6','6.5'],
            2: ['7','7.5','8','8.5','9'],
            3: ['9.5','10','10.5','11','11.5'],
            4: ['12','12.5','13','13.5','14','14.5']
          }

          function findSizeGroup(size) {
            for (let key in lacesSizeMapping) {
              if (lacesSizeMapping[key].includes(size)) {
                return key;
              }
            }
            return null;
          }

          await fetch(`/?section_id=${sectionId}`)
          .then(res => res.text())
          .then(data => {
            const addonHtml = new DOMParser().parseFromString(data, 'text/html');
            const addonSizes = addonHtml?.querySelectorAll('.add-on__option-size-list .add-on__option-size add-on-opener');

            if(addonGender === 'men') {
              addonGroupSize = findSizeGroup(addonSizeMen);
            } else if(addonGender === 'women') {
              addonGroupSize = findSizeGroup(addonSizeWomen);
            }

            if(addonGroupSize) {
              window.addon_current_size_option = addonGroupSize;
              endpoint += `products/${addonSizes[addonGroupSize - 1]?.dataset.productHandle}`;
              variantId = addonSizes[addonGroupSize - 1]?.dataset.variantId;
            }
          })
          .catch(error => console.error(error));
        }


        // case (shoe-care, socks): if parent material tag exists and add-on type is 'shoe-care' than directly open that tab and product upsell
        if(parentMaterialTag !== null && (sectionId === 'add-on__shoe-care' || sectionId === 'add-on__socks')  && parentMaterialTag !== productMaterialFound) {
          await fetch(`/?section_id=${sectionId}`)
          .then(res => res.text())
          .then(data => {
            const addonTab = Array.from(new DOMParser().parseFromString(data, 'text/html')
            .querySelectorAll('.add-on__tabs-list add-on-opener'))?.find(tab => parentMaterialTag.includes(tab.dataset.tabValue));

            if(addonTab) {
              window.cart_upsell_drawer_tab = addonTab.dataset.tab;
              if(!handle) endpoint += `products/${addonTab.dataset.productHandle}`;
              productMaterialFound = addonTab.dataset.productHandle;
            }

          })
          .catch(error => console.error(error));
        }


        if (variantId) {
          params.push('variant=' + variantId);
        }

        endpoint += '?' + params.join('&');
        const response = await fetch(endpoint);
        const data = await response.text();

        // start: keep size-chart popup open if it was previously opened
        const addonSizePopup = this.closest('.add-on')?.querySelector('.addon_size-popup');
        if(addonSizePopup && addonSizePopup.classList.contains('popup-active')) {
          window.is_addon_size_popup_open = true;
        } else {
          window.is_addon_size_popup_open = false;
        }
        // end: keep size-chart popup open if it was previously opened

        this.drawerContent.innerHTML = data;
        // start: keep size-chart popup open if it was previously opened
        if(window.is_addon_size_popup_open) this.drawerContent.querySelector('.addon_size-popup').classList.add('popup-active');
        // end: keep size-chart popup open if it was previously opened
        if(this.dataset.tab) window.cart_upsell_drawer_tab = this.dataset.tab;
        const currentTab = this.drawerContent.querySelector(`[data-tab="${window.cart_upsell_drawer_tab}"]`)?.closest('li') || this.drawerContent.querySelector('[data-tab="1"]')?.closest('li');
        if(currentTab) currentTab.classList.add('active');

        this.drawer.openUpsellDrawer({
          parentLineItemId,
          parentLineItemKey,
          noParent
        });

        // start: hide products that have different family collection than upsell tab block collection
        window.addon_products_handle_arr = [];
        const activeTabValue = this.drawerContent.querySelector('li.active add-on-opener')?.dataset.tabValue;
        const dataScripts = new DOMParser().parseFromString(data, 'text/html').querySelectorAll('.js-addon-products-handle');
        dataScripts?.forEach(script => {
          const scriptFunction = new Function(script.textContent);
          scriptFunction();
        })

        const addonOptions = this.drawerContent.querySelectorAll('.add-on__option .add-on__option-list add-on-opener');
        addonOptions?.forEach((option) => {
          if(!option.hasAttribute('data-selected-option-value')) {
            const tabHandles = window.addon_products_handle_arr.filter(handle => activeTabValue in handle)
            .map(handle => handle[activeTabValue]);
            if(!tabHandles.includes(option.dataset.productHandle)) {
              option.closest('li').classList.add('hidden');
            }
          }
        })
        // end: hide products that have different family collection than upsell tab block collection

        // initialize swiper for the addon
        const hasSingleImg = this.drawerContent.querySelector('.add-on')?.getAttribute('data-has-single-product-image');
        const swiperSelector = '.' + this.drawerContent.querySelector('.add-on')?.getAttribute('data-addon-swiper-initializer');
        if(hasSingleImg === 'false' && swiperSelector) initializeSwiper(swiperSelector);
      }
    }
  );
}